import React, { useState, useEffect } from 'react';
import { CouponItemInfo } from '../Components/CouponItemInfo';
import CouponDownload from '../Components/CouponDownload';
import useFetch from 'use-http';
import { getBookingConfirmation } from '../../../utils/bookingConfirmation';
import {
  clearBookingTrackingData,
  clearExponeaBookingPayload,
  pushBookingConfirmedEvents,
  pushExponeaBookingResultEvent,
  readBookingTrackingData,
  readExponeaBookingPayload,
} from '../../../utils/bookingTracking';
export default function CouponPaymentStep({ orderId }) {
  const [cartItem, setCartItem] = useState();
  const [fileGuids, setFileGuids] = useState();
  const [couponOrderId, setCouponOrderId] = useState();
  const [paymentPending, setPaymentPending] = useState();

  const { request: couponRequest } = useFetch(`/CouponManagement/CouponStatus`);

  const logResultInExponea = (status, result) => {
    const tracking = readBookingTrackingData();
    if (tracking?.kind === 'coupon' && String(tracking.orderId) === String(result?.orderId)) {
      if (status === 'Success') {
        const confirmation = getBookingConfirmation(tracking, result);
        if (confirmation?.confirmed && pushBookingConfirmedEvents(tracking, confirmation)) clearBookingTrackingData();
      } else {
        clearBookingTrackingData();
      }
    }
    const exponea = readExponeaBookingPayload();
    const exponeaOrderId = exponea.find((item) => item.name === 'booking_booking_id')?.value;
    if (result?.orderId != null && String(exponeaOrderId) === String(result.orderId)) {
      try { pushExponeaBookingResultEvent(exponea, status); }
      catch { /* Optional marketing tracking must not block a verified purchase or downloads. */ }
      finally { clearExponeaBookingPayload(); }
    }
  };

  useEffect(() => {
    if (!orderId) return;
    let disposed = false;
    let timeout;
    setPaymentPending(true);
    const check = async () => {
      try {
        const res = await couponRequest.get(`?couponOrderId=${encodeURIComponent(orderId)}`);
        if (disposed) return;
        if (res?.paymentStatus === 'Cancelled') {
          logResultInExponea('Failed', res);
          setPaymentPending(false);
          return;
        }
        if (res?.paymentStatus === 'Paid' && res.succeeded) {
          logResultInExponea('Success', res);
          if (res.fileGuids?.length && !res.waitingForFiles) {
            setCartItem({ price: res.price, comment: res.comment, title: res.couponTitle,
              orderedCount: res.orderedCount, validTo: res.validTo });
            setFileGuids(res.fileGuids);
            setPaymentPending(false);
            return;
          }
        }
      } catch { /* Keep waiting if confirmation or document generation is delayed. */ }
      if (!disposed) timeout = setTimeout(check, 3000);
    };
    check();
    return () => { disposed = true; clearTimeout(timeout); };
  }, [couponRequest, orderId]);

  return (
    <div class="flex flex-col md:flex-row gap-4 w-full">
      <div class="w-full md:w-1/2">
        <CouponDownload fileGuids={fileGuids}></CouponDownload>
      </div>
      <div class="w-full md:w-1/2">
        <CouponItemInfo
          name={cartItem?.title}
          price={cartItem?.price?.toFixed(2)}
          showQuantitySelector={false}
        ></CouponItemInfo>
      </div>
    </div>
  );
}
